import classNames from "classnames"
import { ButtonHTMLAttributes } from "react"
import "./HarvestButton.scss"
import IconSpinner from "../Icons/IconSpinner"

export function HarvestButton({
  className,
  isLoading,
  children,
  disabled,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & { isLoading?: boolean }) {
  return (
    <button
      className={classNames(
        "HarvestButton",
        { "HarvestButton--loading": isLoading },
        className,
      )}
      disabled={isLoading || disabled}
      {...props}
    >
      {isLoading ? (
        <IconSpinner className="HarvestButton__spinner" />
      ) : (
        children
      )}
    </button>
  )
}
